// Centralized test IDs
export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  heritage: 'nav-heritage',
  collections: 'nav-collections',
  boutique: 'nav-boutique',
  b2b: 'nav-b2b',
  contact: 'nav-contact',
  langToggle: 'lang-toggle',
  mobileMenuOpen: 'mobile-menu-open',
  mobileMenuClose: 'mobile-menu-close',
};

export const HOME = {
  hero: 'home-hero',
  heroCta: 'hero-cta-discover',
  heroSecondary: 'hero-cta-collections',
  heritageBlock: 'home-heritage-block',
  collectionsBlock: 'home-collections-block',
  boutiqueBlock: 'home-boutique-block',
  b2bBlock: 'home-b2b-block',
  newsletterInput: 'newsletter-input',
  newsletterSubmit: 'newsletter-submit',
  emergentLink: 'emergent-link',
};

export const CONTACT = {
  name: 'contact-name',
  email: 'contact-email',
  phone: 'contact-phone',
  subject: 'contact-subject',
  message: 'contact-message',
  submit: 'contact-submit',
  success: 'contact-success',
};

export const B2B = {
  company: 'b2b-company',
  contactName: 'b2b-contact-name',
  email: 'b2b-email',
  phone: 'b2b-phone',
  country: 'b2b-country',
  type: 'b2b-business-type',
  website: 'b2b-website',
  message: 'b2b-message',
  submit: 'b2b-submit',
  success: 'b2b-success',
};

export const ADMIN = {
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  loginError: 'admin-login-error',
  logout: 'admin-logout',
  tabStats: 'admin-tab-stats',
  tabContacts: 'admin-tab-contacts',
  tabB2B: 'admin-tab-b2b',
  contactsTable: 'admin-contacts-table',
  b2bTable: 'admin-b2b-table',
};

export const FOOTER = {
  root: 'site-footer',
  tagline: 'footer-tagline',
};
